/* eslint-disable react/jsx-props-no-spreading */
import { FC, useEffect } from 'react'
import ReactGA from 'react-ga4'
import type { ITemplate } from '../interfaces/templates'
import Default from './Default'
import { useOrderDetail } from '../hooks/orders'

/**
 * Order Detail screen, routed at `/:slug/:sessionId/orders/:orderId`.
 *
 * Thin by design, like `OrderHistory` beside it: fetch on mount, fire
 * analytics, delegate rendering to `Default`. `OrderDetailPanel`, its state
 * copy and its custom slots are authored in SCS config and resolve through
 * `importRoute`, so no layout belongs in this file — and the props the config
 * cannot express are injected in `useCinnamonProps`, not passed here.
 * `InjectedDetailProps` in `utils/orderDetailPanel.ts` is the list, checked
 * against the library's own prop type; this comment used to name a count and
 * it was wrong by two the moment `timeZone` and `distributor` landed.
 */
const OrderDetail: FC<ITemplate> = ({ ...props }) => {
  /*
   * The container is handed on so the depot lookup can see whether the
   * authored panel switches its distributor row off (COM-889). It is the same
   * object `Default` renders from below, which is what makes the two agree:
   * anything the lookup decides on the strength of it is a decision about the
   * panel that is actually going to mount.
   */
  useOrderDetail(props.container)

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: `/${props.container.uid}` })
    window.fbq('track', 'PageView', { page: `/${props.container.uid}` })
  }, [])

  return <Default {...props} />
}

export default OrderDetail
